export const SUPPORT_NAME = 'supp0rt';
